import styles from './healthcare-project-card.module.css';

export interface HealthcareProject {
  src: string;
  alt: string;
  title?: string;
}

export default function HealthcareProjectCard({
  src,
  alt,
  title,
}: HealthcareProject) {
  return (
    <article className={styles.projectCard}>
      {title && <h4 className={styles.projectCard_title}>{title}</h4>}
      <div className={styles.projectCard_image}>
        <img src={src} alt={alt} />
      </div>
    </article>
  );
}
